exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu-accesibilidad img[data-v-24ccd881] {\n    max-height: 3.2rem !important;\n    height: 100px;\n}\n", ""]);

// exports
